/**
 * Maps raw Supabase auth errors to friendly, localized message keys.
 */
export type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const getAuthErrorMessage = (error: any, t: TFunc): string => {
  const code: string = error?.code || error?.error_code || '';
  const raw: string = (error?.message || '').toLowerCase();

  const map: Array<[boolean, string]> = [
    [code === 'user_already_exists' || raw.includes('already registered') || raw.includes('user already'),
      'auth.errors.emailInUse'],
    [code === 'weak_password' || raw.includes('password should be'),
      'auth.errors.weakPassword'],
    [code === 'validation_failed' || raw.includes('invalid email') || raw.includes('unable to validate email'),
      'auth.errors.invalidEmail'],
    [code === 'over_email_send_rate_limit' || code === 'over_request_rate_limit' || raw.includes('rate limit') || raw.includes('too many'),
      'auth.errors.tooManyAttempts'],
    [code === 'email_address_invalid', 'auth.errors.invalidEmail'],
    [code === 'signup_disabled', 'auth.errors.signupDisabled'],
    [code === 'invalid_credentials' || raw.includes('invalid login credentials'),
      'auth.errors.invalidCredentials'],
    [code === 'email_not_confirmed' || raw.includes('email not confirmed'),
      'auth.errors.emailNotConfirmed'],
    [raw.includes('failed to fetch') || raw.includes('network') || raw.includes('connect'),
      'auth.errors.network'],
  ];

  const match = map.find(([cond]) => cond);
  if (match) return t(match[1]);

  return error?.message || t('auth.errors.generic');
};
